export type Status = 'Active' | 'Closed' | 'Frozen' | 'Pending' | 'Preparation' | 'Suspended' | 'Unknown';

export const STATUS_SORTING_ORDER: Record<Status, number> = {
  Active: 1,
  Closed: 4,
  Frozen: 2,
  Pending: 5,
  Preparation: 0,
  Suspended: 3,
  Unknown: 6,
};
